module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_09.da8ffaa4.svg";